import React, { Component } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Buffer } from "buffer";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import Pagination from "../pagination/Pagination";
import _ from "lodash";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import PtsAlert from "../ptsAlert/PtsAlert";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

class HistoryForMessageDialog extends Component {
  header = store.getState().header.header;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  paginationState = store.getState().paginations.succSendMsgStatsState;
  paginationStateDetails = {};
  constructor(props) {
    super(props);

    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }

    this.state = {
      message: null,
      historyForMessageList: [],
      messageName: "",
      initialPage: 0,
      pageSize:
        this.paginationStateDetails?.length > 0
          ? this.paginationState?.pageSize
          : 20,
      open: false,
      sortColumn: this.paginationStateDetails?.length > 0
        ? this.paginationState?.sortColumn : null,
      isAscSort: this.paginationStateDetails?.length > 0
        ? this.paginationState?.isAscSort : false,
      sortDirection: "asc",
    };
    this.debouncedSearch = _.debounce(this.showHistoryForMessageList, 800);
  }

  showHistoryForMessageList(message, pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      messageId: message?.id,
      eventid: this.businessDomainId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(
      "/messageLogms/getHistoryForMessageAnalytics",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let historyForMessageList = output.data.logList;
        let page = output.data.page;
        for (let i = 0; i < historyForMessageList.length; i++) {
          historyForMessageList[i].mobile = Utils.viewTollFreeNumberFormate(
            historyForMessageList[i].mobile
          );
          historyForMessageList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(historyForMessageList[i].createdOn, true) : Utils.getUtcToLocalDateTimeZone(
            historyForMessageList[i].createdOn, true
          );
          historyForMessageList[i].scheduledDate = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(historyForMessageList[i].scheduledDate, true) : Utils.getUtcToLocalDateTimeZone(
            historyForMessageList[i].scheduledDate, true
          );
        }

        const sortedHistory = historyForMessageList.sort((a, b) => {
          const statusA = a.deliveryStatus?.trim().toLowerCase();
          const statusB = b.deliveryStatus?.trim().toLowerCase();

          if (statusA === "failed" && statusB !== "failed") return -1; // failed first
          if (statusA !== "failed" && statusB === "failed") return 1;
          return 0;
        });
        this.setState({
          render: true,
          message: message,
          historyForMessageList: sortedHistory,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          pageSize: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
          open: true,
        });
      } else {
      }
    });
  }
  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.message,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const succSendMsgStatsState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.succSendMsgStatsPaginationState({ succSendMsgStatsState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
    });
    this.showHistoryForMessageList(
      this.state.message,
      currentPageIndex,
      pageSize,
      this.state.sortColumn,
      this.state.isAscSort
    );
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  // handleSort(column) {
  //   const { sortColumn, sortDirection, historyForMessageList } = this.state;
  //   let newDirection = "asc";

  //   if (sortColumn === column && sortDirection === "asc") {
  //     newDirection = "desc";
  //   }

  //   this.setState({
  //     historyForMessageList: Utils.sortList(
  //       historyForMessageList,
  //       column,
  //       newDirection
  //     ),
  //     sortColumn: column,
  //     sortDirection: newDirection,
  //   });
  // }

  renderSortIcon(column) {
    if (this.state.sortColumn !== column) return null;

    return this.state.sortDirection === "asc" ? (
      <i className="fa fa-long-arrow-up ps-1" aria-hidden="true"></i>
    ) : (
      <i className="fa-solid fa-arrow-down-long ps-1"></i>
    );
  }

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const succSendMsgStatsState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.succSendMsgStatsPaginationState({ succSendMsgStatsState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
      },
      () => {
        this.showHistoryForMessageList(
          this.state.message,
          pageNo,
          pageSize,
          column,
          isAscSort
        );
      }
    );
  }
  exportMessageOutgoingHistoryData() {
    const postObject = {
      header: this.header,
      smsMessage: { id: this.state.message?.id },
    };

    FetchServerData.callPostService(
      "/csvImpExpms/exportMessageOutgoingHistoryData",
      postObject
    ).then((output) => {
      let AllContactExcelData = output.data;
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        const byteArray = new Buffer(
          AllContactExcelData.data.replace(/^.+base64,/, ""),
          "base64"
        );
        const outputFilename = AllContactExcelData.filename;
        const url = URL.createObjectURL(new Blob([byteArray]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        link.click();
      } else {
      }
    });
  }

  render() {
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="historyForMessageDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Message History</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent className="p-4">
            <div className="row">
              <div className="col">
                <div className="col md-12">
                  <div className="card rounded-0">
                    <div className="row justify-content-between p-2">
                      <div className="d-flex col-12 col-lg-5 col-xl-5">
                        <div className="col-12 text-start totalResults">
                          <span style={{ fontSize: "12px" }}>
                            Messages sent: {this.state.totalRecords}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                        <div className="row d-flex">
                          <div className="col-sm-6 align-self-end text-end">
                            <Button
                              id="downloadReportButton"
                              variant="contained"
                              type="button"
                              startIcon={
                                <i
                                  className="fa fa-download"
                                  style={{ fontSize: "16px" }}
                                ></i>
                              }
                              onClick={this.exportMessageOutgoingHistoryData.bind(
                                this
                              )}
                              className="me-3"
                            >
                              Download Report
                            </Button>
                          </div>
                          <div className="col-sm-6">
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="text"
                              variant="standard"
                              value={this.state.searchText}
                              onChange={this.onSearchChange.bind(this)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      onClick={this.showHistoryForMessageList.bind(
                                        this,
                                        this.state.message,
                                        this.state.pageNo,
                                        this.state.pageSize
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        this.setState(
                                          { searchText: "" },
                                          () => {
                                            this.showHistoryForMessageList(
                                              this.state.message,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            );
                                          }
                                        );
                                      }}
                                      disabled={!this.state.searchText}
                                    >
                                      <ClearIcon
                                        style={{
                                          opacity: this.state.searchText
                                            ? 1
                                            : 0.4,
                                          fontSize: "1.25rem",
                                          color: "353538",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive hfmPaginationTable">
                      <table
                        className="table text-start table-hover"
                        style={{ fontSize: "12px" }}
                      >
                        <thead className="hfmPaginationTableThead">
                          <tr>
                            <th scope="col fw-bold">#</th>
                            <th scope="col fw-bold">Mobile Number</th>
                            <th
                              scope="col fw-bold"
                              onClick={() => this.handleSort("firstName")}
                            >
                              First Name
                              {this.renderSortIcon("firstName")}
                            </th>
                            <th
                              scope="col fw-bold"
                              onClick={() => this.handleSort("lastName")}
                            >
                              Last Name
                              {this.renderSortIcon("lastName")}
                            </th>
                            <th
                              scope="col fw-bold"
                              onClick={() => this.handleSort("email")}
                            >
                              Email
                              {this.renderSortIcon("email")}
                            </th>

                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSort("deliveryStatus")}
                            >
                              Status
                              <InfoTooltip
                                data="Failed numbers will be removed from groups."
                                pageId="Dashboard"
                                style={{
                                  float: "none",
                                  fontSize: "14px",
                                  marginBottom: "3px",
                                  color: "#fff",
                                }}
                              />
                              {this.renderSortIcon("deliveryStatus")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSort("errorMessage")}
                            >
                              Details
                              {this.renderSortIcon("errorMessage")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.historyForMessageList?.map(
                            (rowData, index) => (
                              <tr key={index}>
                                <td style={{ width: "60px" }}>{index + 1}</td>
                                <td style={{ width: "190px" }}>
                                  {rowData.mobile}
                                </td>
                                <td style={{ width: "140px" }}>
                                  {rowData.firstName}
                                </td>
                                <td style={{ width: "140px" }}>
                                  {rowData.lastName}
                                </td>
                                <td style={{ width: "200px" }}>
                                  {rowData.email}
                                </td>
                                <td style={{ width: "140px" }}>
                                  {rowData.deliveryStatus}
                                </td>
                                <td style={{ width: "255px" }}>
                                  {rowData.errorMessage}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && (
                      <div
                        className="row text-center"
                        style={{ padding: "6px 20px" }}
                      >
                        <h5 className="dataNotAvailable">No data found.</h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-1">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="pageSize col-12 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default HistoryForMessageDialog;
